import { DropdownMenu, MenuItemProps } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";
import { HighlightChangeDetails } from "@zag-js/menu";
import { Guid } from "@iconics/core";

export class DropDownMenu extends BaseComponent<IDropDownMenuProps, IDropDownMenuState>
{
    private inputId = Guid.new().toString().toLowerCase();

    constructor(props: IDropDownMenuProps)
    {
        super(props);
        this.state =
        {
            highlightedValue: undefined,
        };
    }

    private get selectedItem(): MenuItemProps | undefined
    {
        return this.props.items.find(i => i.value == this.props.selectedValue);
    }

    private handleOpenChange(details: IDropDownMenuOpenChangeDetails): void
    {
        const popper = document.getElementById(`menu:${this.inputId}:popper`);
        if (popper && !popper.classList.contains('serendie-drop-down-menu__popper'))
        {
            popper.classList.add('serendie-drop-down-menu__popper');
        }

        this.setState({ highlightedValue: this.selectedItem?.value ?? this.props.highlightedValue ?? undefined });
        this.props.onOpenChange?.(details);
    }

    private handleHighlightChange(event: HighlightChangeDetails)
    {
        if (event.highlightedValue)
        {
            this.setState({ highlightedValue: event.highlightedValue });
        }
        this.props.onHighlightChange?.(event);
    }

    public render(): JSX.Element
    {
        const selectedItem = this.selectedItem;
        const placeholder = selectedItem?.label ?? this.props.placeholder ?? '';

        return (
            <div
                className='serendie-drop-down-menu'
            >
                <label
                    htmlFor={`menu:${this.inputId}:trigger`}
                    className='serendie-drop-down-menu__label'
                >
                    {this.props.label}
                    {
                        this.props.required &&
                        <span
                            className='serendie-drop-down-menu__required'
                        >
                            {this.props.requiredLabel}</span>
                    }
                </label>
                <DropdownMenu
                    id={this.inputId}
                    {...this.props}
                    title={placeholder}
                    highlightedValue={this.state.highlightedValue}
                    onHighlightChange={e => this.handleHighlightChange(e)}
                    onOpenChange={e => this.handleOpenChange(e)}
                />
                {
                    this.props.invalid &&
                    <div
                        className='serendie-drop-down-menu__invalid'
                    >
                        {this.props.invalidMessage}</div>
                }
            </div>
        )
    }
}

export interface IDropDownMenuProps extends Omit<React.ComponentProps<typeof DropdownMenu>, 'title'>
{
    label: string;
    placeholder?: string;
    selectedValue?: string;
    required?: boolean;
    requiredLabel?: string;
    invalid?: boolean;
    invalidMessage?: string;
}

export interface IDropDownMenuState
{
    highlightedValue?: string;
}

export interface IDropDownMenuOpenChangeDetails
{
    open: boolean;
}
